import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setShowOnePersonModal } from '../../api/single-person/alert.api';

export const useSetShowOnePersonModal = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (showModal: boolean) => setShowOnePersonModal(showModal),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey:
          queryKeyStore.companyCreation.showOnePersonModalNextTime.queryKey,
      }),
  });
};
